class Cache {
  setItem(key, val, once) {
    if (once === true && this.getItem(key) !== undefined) {
      return false;
    }

    if (val === undefined) {
      return false;
    }

    try {
      localStorage.setItem(key, JSON.stringify(val));

      return true;
    }

    // most likely a quota exceeded error
    catch (e) {
      return !!(window.console && console.warn(e));
    }
  }

  getItem(key) {
    let val = localStorage.getItem(key);

    if (val !== null) {
      return JSON.parse(val);
    }

    return undefined;
  }

  removeItem(key) {
    if (key in localStorage) {
      localStorage.removeItem(key);
      return true;
    }

    return false;
  }

  clear(pattern) {
    if (pattern) {
      Object.keys(localStorage).forEach(function (key) {
        if (key.match(pattern)) {
          localStorage.removeItem(key);
        }
      });
    }
  }
}

module.exports = Cache;